import Vue from 'vue'

import axios from 'axios'

if (process.env.NODE_ENV === "development") {
    axios.defaults.baseURL = 'http://localhost:8080';
} else {
    axios.defaults.baseURL = '';
}

axios.defaults.withCredentials = true;

axios.interceptors.response.use(function (response) {
    console.log(response)

    // 如果返回的code为2说明没有登录且不在登录页，跳转到登录页面
    if (response.data.code === 2) {
        if (window.location.pathname.indexOf("login") >= 0) {
            // 在登陆页面，不跳转
        } else {
            if (window.location.pathname.indexOf('liquor') >= 0) {

                window.location.href = "/liquor/login"
            } else {
                window.location.href = "/login"
            }
        }

    }
    return response;
}, function (error) {
    // 如果返回的error含有403说明没有登录且不在登录页，跳转到登录页面
    if (error.toString().indexOf('403') >= 0) {
        if (window.location.pathname.indexOf("login") >= 0) {
            // 在登陆页面，不跳转
        } else {
            if (window.location.pathname.indexOf('liquor') >= 0) {

                window.location.href = "/liquor/login"
            } else {
                window.location.href = "/login"
            }
        }
    }
    return Promise.reject(error);
});

const ajax = async (url, params) => {
    const data = new FormData();
    if (params) {
        Object.keys(params).forEach(k => {
            if (params[k]) {
                data.append(k, params[k])
            }
        })
    }
    const response = await axios({
        url,
        method: "POST",
        data
    })
    return response.data
}

const doRest = async ({ packageName, className, methodName, params }) => {
    const response = await axios({
        url: `/api/${packageName}/${className}/${methodName}`,
        method: "POST",
        data: params
    });

    return response.data.data;
}


const doPost = async ({ packageName, className, methodName, params }) => {
    const response = await ajax(`/api/${packageName}/${className}/${methodName}`, params);

    return response.data;
}

const Ajax = {
    install(Vue) {
        Vue.prototype.ajax = this.ajax;
    },
    ajax: {
        doPost,
        doRest
    }
}

export default Ajax.ajax;

Vue.use(Ajax);